import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { SITE } from "../lib/siteConfig";

const LINKS = [
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact Us" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Use" },
  { to: "/affiliate-disclosure", label: "Affiliate Disclosure" },
  { to: "/partners", label: "For Brands & Retailers" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white/80 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="bg-white/95 inline-flex rounded-xl px-3 py-2">
              <Logo height="h-9" />
            </div>
            <p className="mt-3 font-heading font-bold uppercase tracking-[0.18em] text-brand text-xs" data-testid="footer-tagline">{SITE.tagline}</p>
            <p className="mt-4 text-sm leading-relaxed max-w-xs">
              Coordinated family outfits, official size charts, and optional accessories.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-extrabold text-white text-sm uppercase tracking-wider mb-4">Company</h4>
            <nav aria-label="Company"><ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="text-sm hover:text-white transition-colors inline-flex items-center min-h-[44px]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul></nav>
          </div>

          <div>
            <h4 className="font-heading font-extrabold text-white text-sm uppercase tracking-wider mb-4">Get in touch</h4>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email"
              className="flex items-center gap-2 text-sm hover:text-white transition-colors min-h-[44px]"
            >
              <Mail size={16} className="text-brand shrink-0" /> {SITE.email}
            </a>
            <p className="flex items-start gap-2 text-sm mt-3">
              <MapPin size={16} className="text-brand shrink-0 mt-0.5" /> {SITE.address}
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p data-testid="footer-legal-name">© {new Date().getFullYear()} {SITE.legalName}. All rights reserved. | {SITE.domain}</p>
          <p>SIBLINGO is a service of {SITE.legalName}.</p>
        </div>
      </div>
    </footer>
  );
}
